/**
 * 移动端主题
 */
import { axisPointerThemeParse } from './component/axisPointer';
import { barThemeParse } from './series/bar';
import { lineThemeParse } from './series/line';
import { treemapThemeParse } from './series/treemap';
import { dvScatterThemeParse } from './series/dvScatter';
import { dvMarkerThemeParse } from './series/dvMarker';
import { darkThemeParse as dvTwoWayTreeDarkThemeParse } from './series/dvTwoWayTree';
import { dataZoomThemeParse } from './component/dataZoom';
import { graphicParse } from './component/graphic';

export const mobileAppLight = {
  name: 'mobile-app-light' as const,
  parsers: [
    // series
    barThemeParse,
    lineThemeParse,
    treemapThemeParse,
    dvScatterThemeParse,
    dvMarkerThemeParse,
    // component
    axisPointerThemeParse,
    dataZoomThemeParse,
    graphicParse
  ]
};

export const mobileAppDark = {
  name: 'mobile-app-dark' as const,
  parsers: [
    // series
    barThemeParse,
    lineThemeParse,
    dvTwoWayTreeDarkThemeParse,
    dvScatterThemeParse,
    dvMarkerThemeParse,
    // component
    dataZoomThemeParse,
    axisPointerThemeParse,
    graphicParse
  ]
};
